function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 120,
  fill: "#00C896",
  fillRule: "nonzero",
  rx: 60
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M65.996 53.782a6.8 6.8 0 0 0-2.087.33c-.972.316-4.152 1.653-4.268 5.612a10.115 10.115 0 0 0 0 .548c.116 3.963 3.296 5.3 4.268 5.617 2.071.672 5.004.473 7.025-2.102a.874.874 0 0 0 .023-.03L73.952 60l-2.995-3.757a.323.323 0 0 0-.024-.029c-1.403-1.79-3.247-2.432-4.937-2.432M61.337 26.6c-.16 0-.32 0-.48.003-17.417.239-31.301 13.107-33.007 29.9-1.939 19.08 12.853 36.143 32.165 36.875 10.818.41 20.974-4.233 27.679-12.593a2.835 2.835 0 0 0-.012-3.559l-7.04-8.832a.67.67 0 0 0-1.046 0l-1.04 1.304C74.35 75.044 67.424 77.129 60.9 75.01c-6.444-2.092-10.733-7.767-10.928-14.456a17.514 17.514 0 0 1 0-1.112c.196-6.685 4.485-12.36 10.928-14.452 6.523-2.12 13.45-.033 17.655 5.312l1.04 1.306a.67.67 0 0 0 1.046 0l7.04-8.833a2.869 2.869 0 0 0-.026-3.607C81.21 31.162 71.64 26.599 61.337 26.599M61.336 103c-11.58 0-22.462-4.471-30.646-12.59C22.507 82.287 18 71.49 18 60 18 48.6 22.422 37.87 30.453 29.786c8.031-8.084 18.782-12.623 30.27-12.78 6.822-.095 13.37 1.341 19.463 4.264a43.648 43.648 0 0 1 15.027 11.908c3.684 4.576 3.706 10.972.055 15.552L86.285 60l8.983 11.272c3.644 4.571 3.642 10.941-.004 15.489C86.987 97.08 74.621 103 61.336 103"
}));

var SvgIcClassting = function SvgIcClassting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClassting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-classting.1b697684.svg";
export { ForwardRef as ReactComponent };